export enum ERoutes {
  HOME = "",
  HISTORY = "history",
  IFRAME = "iframe",
  INTERFACE = "interface",
  MAP = "map",
  STATISTICS = "statistics",
  TEST = "test",
  LIVE_MAP = "live",
  LOOP_1 = "series-step-1",
  LOOP_2 = "series-step-2",
  LOOP_3 = "series-step-3",
  LOOP_RESULT = "series-result",
  CERTIFIED_1 = "certified-step-1",
  CERTIFIED_2 = "certified-step-2",
  CERTIFIED_3 = "certified-step-3",
  CERTIFIED_4 = "certified-step-4",
  CERTIFIED_RESULT = "certified-result",
  OPEN_DATA = "opentests",
  OPEN_RESULT = "opentest",
  OPTIONS = "options",
  RESULT = "result",
  TERMS = "terms-and-conditions",
  SITEMAP = "sitemap",
  SPOTS = "spots",
  SPOT_DETAILS = "spot-details",
  INSIGHT = "insight",
  HUB = "hub",
  ABOUT = "about",
}
